import React from "react";
import { useQuery } from "@apollo/client";

import photoExamplesQuery from "queries/photoExamples";
import Loader from "../loader";
import styles from "./style.module.scss";

const Wheel = () => {
  const { loading, data } = useQuery(photoExamplesQuery);

  if (loading) {
    return (
      <div id="wheel" className={styles.wheel__main}>
        <div className={styles.wheel__container}>
          <header className={styles.wheel__jobs}>НАШИ РАБОТЫ:</header>
          <Loader />
        </div>
      </div>
    );
  }

  const photos = data?.photoExamplesCollection?.items || [];

  return (
    <div id="wheel" className={styles.wheel__main}>
      <div className={styles.wheel__container}>
        <header className={styles.wheel__jobs}>НАШИ РАБОТЫ:</header>
        <div className={styles.wheel__images}>
          {photos.map((item, index) => {
            if (!item.photo || !item.photo.url) {
              return null;
            }

            return (
              <div key={index} className={styles.wheel__wrapper}>
                <img
                  className={styles.wheel__picture}
                  src={item.photo.url}
                  alt={item.photo.description || `Пример работы ${index + 1}`}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Wheel;